// extracted by mini-css-extract-plugin
module.exports = {"cropped-text":"cropped-text--YWDtu8Dkgq","croppedText":"cropped-text--YWDtu8Dkgq","whole":"whole--2Q0TLC147p","front":"front--2pvTk6VoJK","back":"back--1CTZS0sOFl"};